import List from '../../components/List';
import LoadMoreComponent from '../../components/LoadMoreComponent';

import query from './query';
import keysFunction, { COLUMNS } from '../PageCard/keys';
import DataTable from '../../components/Datatable';
import { scrollForTable } from '../../components/Datatable/utils';
import Loading from '../../components/Loading';
import { colors } from '../../lib/colors';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

class Summary extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({ page: props.page });
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.title?.toLowerCase().includes(search.toLowerCase()));
    }

    getLast3FullMonthsDateRange() {
        const startOfCurrentMonth = moment().startOf('month');
        const endDate = startOfCurrentMonth.clone().subtract(1, 'day').endOf('day');
        const startDate = startOfCurrentMonth.clone().subtract(3, 'months').startOf('month');

        return {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD'),
        };
    }

    render() {
        const { t } = this.props;
        // if we get less than offsetStep it means we don't have more data
        const { startDate, endDate } = this.getLast3FullMonthsDateRange();

        const exploreUrlLink = `/domains/tools/live-url/?domain=${this.props.domain_url}&url=${this.props.page}&start_date=${startDate}&end_date=${endDate}`;
        const keys = keysFunction(this.props.default_image, this.props.page, exploreUrlLink, t);
        const sortFns = {
            title: (array) => array.sort((a, b) => a.title.localeCompare(b.title)),
            headline: (array) => array.sort((a, b) => a.headline.localeCompare(b.headline)),
            author: (array) => array.sort((a, b) => a.author.localeCompare(b.author)),
            ogtitle: (array) => array.sort((a, b) => a.ogtitle.localeCompare(b.ogtitle)),
            schema: (array) => array.sort((a, b) => a.schema.localeCompare(b.schema)),
            words: (array) => array.sort((a, b) => a.words - b.words),
            firstSeen: (array) =>
                array.sort((a, b) => new Date(a.firstSeen) - new Date(b.firstSeen)),
            modified: (array) => array.sort((a, b) => new Date(a.modified) - new Date(b.modified)),
            published: (array) =>
                array.sort((a, b) => new Date(a.published) - new Date(b.published)),
        };
        return (
            <>
                <div className="card rounded-main overflow-hidden">
                    <div className="card-body secondary">
                        {this.state.loading ? (
                            <Loading padding={10} />
                        ) : (
                            <List
                                className="table-main"
                                loading={this.state.loading}
                                data={this.state.allData.length ? [this.state.allData[0]] : []}
                                parent_id="page-content"
                                content_id="page-card"
                                keys={keys}
                                color={colors[1]}
                                header={false}
                            />
                        )}
                    </div>
                </div>
                <div className="card rounded-main table-main overflow-hidden">
                    {this.state.loading ? (
                        <Loading padding={10} />
                    ) : (
                        <DataTable
                            nodes={this.state.allData}
                            sortFns={sortFns}
                            COLUMNS={COLUMNS(t)}
                            fileName="PageCard"
                            forceRun={this.forceRun}
                            searchFunction={this.searchFunction}
                            header={t('discover.page.article_history.header')}
                            additionalStyles={{
                                Table: `
                                        --data-table-library_grid-template-columns :  minmax(200px, 2fr) minmax(150px, 1.5fr) minmax(150px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr)  minmax(120px, 1fr)  minmax(120px, 1fr)  minmax(120px, 1fr)  minmax(120px, 1fr)  !important;
                                        ${scrollForTable}
                                    `,
                                BaseCell: `  font-family: 'Raleway';
                                                font-weight: 500;
                                                font-size: 16px;
                                                line-height: 19px;
                                                padding: 16px 10px !important;
                                                color: #0D182C;
                                            
                                            
                                                &.underline {
                                                    text-decoration: underline;
                                                }
                                                `,
                            }}
                        />
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
